import React, { FC } from 'react';
import Form from 'components/Form';

import { DettolPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Dettol: FC<DettolPageProps> = ({ pageContext, location }) => (
  <Form {...{
    ...{ ...pageContext, location, translations: { ...pageContext.translations, pageTitle: '' } },
  }} />
);

export default Dettol;
